<span class="avatar size-{{ size }} object-fit-cover bg-light-{{ fullName | color }}">
  <img
    *ngIf="avatar?.length > 0"
    class="bg-light-{{ fullName | color }}"
    [width]="size"
    [height]="size"
    [src]="url ?? (avatar | avatarUrl)"
    alt="avatar"
    loading="lazy"
  />
  <span
    *ngIf="!avatar?.length"
    class="avatar-content size-{{ size }} bg-light-{{ fullName | color }}"
  >
    {{ fullName | initials | uppercase }}
  </span>
</span>
